<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('loan types')"
      :columns="columns"
      :column_search="true"
      resource_url="/loan/loan-type/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="create_loan_type"
        >
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <loan-type-modal ref="loan_type_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import LoanTypeModal from "./loan_type_modal/Index.vue";

export default {
  name: "LoanTypeDataTable",
  components: { GenericTable, LoanTypeModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${row.name}</div>
            <div class="subtitle is-7">${row.description || ""}</div>`;
          },
        },
        {
          title: v.$t("amount range"),
          searchable: false,
          data: (row) => {
            return `${format_currency(row.min_amount)} - ${format_currency(
              row.max_amount
            )}`;
          },
        },
        {
          title: v.$t("quotas range"),
          searchable: false,
          data: (row) => {
            return `${row.min_quotas} - ${row.max_quotas}`;
          },
        },
        {
          title: v.$t("interest rate"),
          searchable: false,
          data: (row) => {
            return `${row.interest_rate}%`;
          },
        },
        {
          title: v.$t("payment frequency"),
          searchable: false,
          data: (row) => {
            return v.$t(row.payment_frequency);
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            return row.is_active
              ? `<span class="tag is-success">${v.$t("active")}</span>`
              : `<span class="tag is-dark">${v.$t("inactive")}</span>`;
          },
        },
        {
          title: v.$t("actions"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_loan_type(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete this item?"),
                    v,
                    () => {
                      del("/loan/loan-type", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create_loan_type() {
      this.$refs.loan_type_modal.show_modal();
    },
    edit_loan_type(uuid) {
      this.$refs.loan_type_modal.show_modal(uuid);
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
